import React from 'react';
// import Lottie from 'react-lottie';
import './Deposit_Lottie.css';
import * as animationData from './Deposit_Lottie.json';
import Lottie from 'lottie-react';

function Deposit_Lottie(){
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
      };
    
    return (
      <section className='main'>
            <div className='Deposit_Lottie_icon'>
                <Lottie className="me-auto"
                options={defaultOptions}        
                />       
        </div>
      </section>
    );
}
export default Deposit_Lottie;